import {
  EmailItem,
  InputItem,
  PhoneNumberItem,
  PreferredLanguageItem,
  SelectItem,
  StateItem,
  CheckboxItem,
  RadioItem,
  Note,
  GenderItem,
  CheckboxGroupItem,
  GenericPhysicianItem,
  GenericFacilityItem,
  PayerItem,
  AttachmentsField,
  CurrencyItem,
  PrescriptionItem,
  DiagnosisDetails,
  CaregiverRadioItem
} from "../../form";
import { DateFormItem, DobFormItem } from "../../../components";
import { FieldMultiplier } from "../FieldMultiplier";
import { EligibilityQuestionnaireField } from "../EligibilityQuestionnaireField";
import { InfoNoticeField } from "../InfoNoticeField";
import { ConsentTextField } from "../ConsentTextField";
import customFieldsRegistry from "../../../../../customField/customFieldsRegistry";

export const formFieldComponents = Object.freeze({
  input: InputItem,
  phone: PhoneNumberItem,
  email: EmailItem,
  singleSelect: SelectItem,
  datepicker: DateFormItem,
  dob: DobFormItem,
  gender: GenderItem,
  language: PreferredLanguageItem,
  state: StateItem,
  checkbox: CheckboxItem,
  checkboxGroup: CheckboxGroupItem,
  radio: RadioItem,
  caregiverRadio: CaregiverRadioItem,
  note: Note,
  physician: GenericPhysicianItem,
  facility: GenericFacilityItem,
  payer: PayerItem,
  fieldMultiplier: FieldMultiplier,
  attachments: AttachmentsField,
  currency: CurrencyItem,
  diagnosis: DiagnosisDetails,
  prescription: PrescriptionItem,
  // native EE concepts (self-contained: they read their own context from the store)
  eligibilityQuestionnaire: EligibilityQuestionnaireField,
  // drug-conditional legal/consent copy — display-only; reads the current application's drug name itself
  consentText: ConsentTextField,
  // shared bordered light-blue info box (e.g. the practice-NPI portal notice)
  infoNotice: InfoNoticeField,
  ...customFieldsRegistry
});

export default formFieldComponents;
